import React from 'react';
interface PatternDecorProps {
  side: 'left' | 'right';
  y?: 'top' | 'middle' | 'bottom';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
// Decorative pattern removed sitewide — component intentionally renders nothing
// so existing usages and props remain valid without showing the pattern.
export function PatternDecor(_props: PatternDecorProps) {
  return null;
}